var VALETTE = VALETTE || {};

VALETTE.shippingMessage = function() {
	var specialMessageModal = $.cookie('specialmessage');
	if (specialMessageModal == 'read') {
		return;
	} else {
		setTimeout(function(){
			$('#figureMessageModal').modal();
		}, 3000);	
	}	
	$('#figureMessageModal').on('hide.bs.modal', function (event) {
		$.cookie('specialmessage', 'read', { path: '/' });
	});
	$('#figureMessageModal a').click(function() {
		$.cookie('specialmessage', 'read', { path: '/' });
	});
}();

VALETTE.carousels = function() {
	$(window).on('load', function() {
		const carousels = ['.team-carousel'];
		const prevButton = '#tns_slider_prev';
		const nextButton = '#tns_slider_next';
		$(window).ready(() => {
			carousels.forEach(container => {
				if (!$(container).length) return;
				let teamSlider = tns({
					container,
					items: 1,
					loop: true,
					nav: false,
					slideBy: 'page',
					mouseDrag: true,
					autoWidth: true,
					center: true,
					autoplay: true,
					autoplayText: ['▶', '❚❚'],
					autoplayTimeout: 8000,
					prevButton,
					nextButton,
					responsive: {
					},
					onInit: function() {
						$('.team-carousel').css({
							opacity: 1,
						});
					}
				});
				const info = teamSlider.getInfo();

				const startingIndex = info.index;
				$('.tns-item').each((index, item) => item.classList.add('inactive'));
				info.slideItems[startingIndex].classList.remove('inactive');
				teamSlider.events.on('indexChanged', e => {
					const index = e.index;
					$('.tns-item').each((index, item) => $(item).addClass('inactive'));
					$(e.slideItems[index]).removeClass('inactive');
				});
			});
		});
	});
}();

VALETTE.navClose = function() {
	$('.subnav a').click(function() {
		$('.open-nav').click();
	});
}();
